const segment = {
  5000: 'investigate',
  5001: 'show-in-alert-console',
  5002: 'tune-alert',
};

export default segment;
